import { memo } from 'react';
import { ToastContainer, Bounce } from 'react-toastify';
import styles from './styles.module.css';

export const Toast = memo(() => (
  <ToastContainer
    position="top-right"
    autoClose={3000}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    theme="dark"
    transition={Bounce}
    className={styles.toast}
  />
));
